import { SQLiteDBConnection } from '@capacitor-community/sqlite';
import { Injectable} from '@angular/core';
import { SQLiteService } from './sqlite.service';
import { DbnameVersionService } from './dbname-version.service';
import { UserUpgradeStatements } from '../upgrades/user.upgrade.statements';
import {capSQLiteChanges, capSQLiteSet} from "@capacitor-community/sqlite/src/definitions";

@Injectable()
export class StorageService {
  private databaseName: string = "";
  private uUpdStmts: UserUpgradeStatements = new UserUpgradeStatements();
  private versionUpgrades;
  private loadToVersion;
  public db!: SQLiteDBConnection;

  constructor(public sqliteService: SQLiteService, private dbVerService: DbnameVersionService) {
    this.versionUpgrades = this.uUpdStmts.userUpgrades;
    this.loadToVersion = this.versionUpgrades[this.versionUpgrades.length-1].toVersion;
  }
  async initializeDatabase(dbName: string) {
    console.log('inicializando database versao ', this.loadToVersion)
    this.databaseName = dbName;
    // create upgrade statements
    // await this.sqliteService
    //   .addUpgradeStatement({
    //     database: this.databaseName,
    //     upgrade: this.versionUpgrades
    //   });
    // create and/or open the database
    // this.db = await this.sqliteService.openDatabase(this.databaseName,
    //   false,
    //   'no-encryption',
    //   this.loadToVersion,
    //   false
    // );
    this.dbVerService.set(this.databaseName, this.loadToVersion);
  }

  // async executeSet(
  //   set: capSQLiteSet[],
  //   transaction = true,
  //   returnMode = 'no',
  //   isSQL92 = true,
  // ): Promise<capSQLiteChanges> {
  //   return this.db.executeSet(set, transaction, returnMode, isSQL92)
  // }

}
